import { globals, page as pageIndex } from '../../globals'
import { UPDATE_DATA, actionHandler } from './updateData'
import moment from 'moment'
// ------------------------------------
// Constants
// ------------------------------------
export const GET_CLIENTS_START = 'GET_CLIENTS_START'
export const GET_CLIENTS_FETCHED = 'GET_CLIENTS_FETCHED'
export const GET_CLIENTS_FAILED = 'GET_CLIENTS_FAILED'
export const RETURN_DEFAULT_REPORT = 'RETURN_DEFAULT_REPORT'
export const START_CLIENTS_DATA_FETCH = 'START_DATA_FETCH'
export const CLIENTS_DATA_FETCHED = 'CLIENTS_DATA_FETCHED'
export const FETCH_CLIENTS_DATA_FAILED = 'FETCH_CLIENTS_DATA_FAILED'
export const GET_GROUP_NOTES_START = 'GET_GROUP_NOTES_START'
export const GET_GROUP_NOTES_FAILED = 'GET_GROUP_NOTES_FAILED'
export const GET_GROUP_NOTES_FETCHED = 'GET_GROUP_NOTES_FETCHED'
export const GET_SINGLE_CLIENT_START = 'GET_SINGLE_CLIENT_START'
export const GET_SINGLE_CLIENT_FAILED = 'GET_SINGLE_CLIENT_FAILED'
export const OPEN_CLIENT = 'OPEN_CLIENT'
export const CLEAR_GROUP_NOTES = 'CLEAR_GROUP_NOTES'
// ------------------------------------
// Actions
// ------------------------------------
export const getManagementData = (location) => {
  return (dispatch) => {
    dispatch({ type: START_CLIENTS_DATA_FETCH })
    const headers = {
      'Content-Type': 'application/json',
    }
    const options = {
      method: 'GET',
      credentials: 'include',
      headers,
    }
    fetch(`${globals.apiUrl}/api/clientmanagement`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else {
        dispatch({
          type: FETCH_CLIENTS_DATA_FAILED,
          payload: {
            errorCode: response.status
          }
        })
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: CLIENTS_DATA_FETCHED,
          payload: {
            json,
          },
          location: {
            page: location.page,
            field: location.field,
          },
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: FETCH_CLIENTS_DATA_FAILED })
    })
  }
}

export function getClientList () {
  return (dispatch) => {
    dispatch({ type: GET_CLIENTS_START })
    const headers = {
      'Content-Type': 'application/json',
    }
    const options = {
      method: 'GET',
      credentials: 'include',
      headers,
    }
    fetch(`${globals.apiUrl}/api/client`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else {
        dispatch({
          type: GET_CLIENTS_FAILED,
          payload: {
            errorCode: response.status
          }
        })
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: GET_CLIENTS_FETCHED,
          payload: {
            json,
          },
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: GET_CLIENTS_FAILED })
    })
  }
}

export function getSingleClient (clientId) {
  return (dispatch) => {
    dispatch({ type: GET_SINGLE_CLIENT_START })
    const headers = {
      'Content-Type': 'application/json',
    }
    const options = {
      method: 'GET',
      credentials: 'include',
      headers,
    }
    fetch(`${globals.apiUrl}/api/client/${clientId}`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else {
        dispatch({
          type: GET_SINGLE_CLIENT_FAILED,
          payload: {
            errorCode: response.status
          }
        })
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: OPEN_CLIENT,
          payload: {
            json,
          },
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: GET_SINGLE_CLIENT_FAILED })
    })
  }
}

export function returnDefaultState (page) {
  return {
    type: RETURN_DEFAULT_REPORT,
    page,
  }
}

export function getGroupNotes (clientId) {
  return (dispatch) => {
    dispatch({ type: CLEAR_GROUP_NOTES })
    dispatch({ type: GET_GROUP_NOTES_START })
    const headers = {
      'Content-Type': 'application/json',
    }
    const options = {
      method: 'GET',
      credentials: 'include',
      headers,
    }
    fetch(`${globals.apiUrl}/api/groupnotesfield?clientid=${clientId}`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else {
        dispatch({
          type: GET_GROUP_NOTES_FAILED,
          payload: {
            errorCode: response.status
          }
        })
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: GET_GROUP_NOTES_FETCHED,
          payload: {
            json,
          },
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: GET_GROUP_NOTES_FAILED })
    })
  }
}

function returnLocalities (data) {
  let statesList = []
  let resultedArray = []
  for (let i = 0; i < data.length - 1; i++) {
    if (!statesList.includes(data[i]['RegionName'])) {
      statesList = [...statesList, data[i]['RegionName']]
    }
  }
  let sortedList = statesList.sort(function (a, b) {
    if (a < b) return -1
    if (a > b) return 1
    return 0
  })
  for (let i = 0; i < sortedList.length; i++) {
    const localities = data.filter(el => el.RegionName === sortedList[i])
    const countyShort = 'CO.'
    resultedArray[i] = {
      text: sortedList[i],
      id: localities[0].RegionCode,
      shortcut: localities[0].RegionCode + ': All',
      type: 'ch_with_child',
      localityIds: localities.map(item => item.LocalityId),
      locality: localities.map(e => {
        const name = e.Name.includes('County')
          ? e.Name.split('County')[0] + e.Name.split('County')[1] + countyShort
          : e.Name
        return {
          text: e.Name,
          id: e.LocalityId,
          shortcut: e.RegionCode + ': ' + name,
          type: 'children',
        }
      })
    }
  }
  return resultedArray
}
// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_DATA] : (state, action) => action.location.page !== pageIndex.cmd ? state : actionHandler(state, action),
  [START_CLIENTS_DATA_FETCH] : (state) => {
    return {
      ...state,
      isFetchingData: true
    }
  },
  [CLIENTS_DATA_FETCHED] : (state, action) => {
    const { page, field } = action.location
    const { json } = action.payload
    if (page !== pageIndex.cmd) {
      return state
    }
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        [page]: {
          ...state.renderData[page],
          [field]: {
            ...state.renderData[page][field],
            accountManagers: json.AccountManagers,
            accountTypes: json.AccountTypes,
            localityList: returnLocalities(json.LocalityList),
            regionList: json.RegionList
          }
        }
      },
      formDataValue: {
        ...state.formDataValue
      }
    }
  },
  [GET_CLIENTS_START] : (state) => {
    return {
      ...state,
    }
  },
  [GET_CLIENTS_FETCHED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      renderData: {
        ...state.renderData,
        C: {
          ...state.renderData.C,
          groupNotes: {
            ...state.renderData.C.groupNotes,
            findClientList: json
          }
        }
      },
      formDataValue: {
        ...state.formDataValue
      }
    }
  },
  [FETCH_CLIENTS_DATA_FAILED] : (state) => {
    return {
      ...state,
    }
  },
  [GET_CLIENTS_FAILED] : (state) => {
    return {
      ...state,
    }
  },
  [RETURN_DEFAULT_REPORT] : (state, action) => {
    const { page } = action
    if (page !== pageIndex.cmd) {
      return state
    }
    return {
      ...initialState,
      isFetchingData: false,
      renderData: {
        ...state.renderData
      }
    }
  },
  [GET_GROUP_NOTES_START] : (state) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
        C: {
          ...state.renderData.C,
          groupNotes: {
            ...state.renderData.C.groupNotes,
            isFetchingGroupNotes: true
          }
        }
      }
    }
  },
  [GET_GROUP_NOTES_FETCHED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      renderData: {
        ...state.renderData,
        C: {
          ...state.renderData.C,
          groupNotes: {
            ...state.renderData.C.groupNotes,
            isFetchingGroupNotes: false,
            groupNotesFields: json
          }
        }
      }
    }
  },
  [GET_GROUP_NOTES_FAILED] : (state) => {
    return {
      ...state,
      renderData: {
        ...state.renderData
      }
    }
  },
  [OPEN_CLIENT] : (state, action) => {
    const { json } = action.payload
    const selected = json.IsFormerClient && json.SignedContract
      ? ['formerClient', 'signedOnFile']
      : json.IsFormerClient ? ['formerClient'] : json.SignedContract ? ['signedOnFile'] : []
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        C: {
          ...state.formDataValue.C,
          defaultSearch: {
            ...state.formDataValue.C.defaultSearch,
            title: json.Name,
            selected: selected,
            textValues: {
              ...state.formDataValue.C.defaultSearch.textValues,
              clientId: json.ClientId,
              shortName: json.ShortName ? json.ShortName : '',
              fullName: json.Name ? json.Name : '',
              address0: json.WelcomeName ? json.WelcomeName : '',
              address1: json.StreetAddress1 ? json.StreetAddress1 : '',
              address2: json.StreetAddress2 ? json.StreetAddress2 : '',
              address3: json.City + ' ' + json.State + ' ' + json.ZipCode,
              address4: json.Industry ? json.Industry : '',
              address5: json.Website ? json.Website : '',
              description: json.AnalystNotes ? json.AnalystNotes : '',
              notes: json.ManagementComments ? json.ManagementComments : '',
            },
            radio: {
              ...state.formDataValue.C.defaultSearch.radio,
              aType: json.ClientType ? json.ClientType : 'type 1',
              aManager: json.AccountManagerId ? json.AccountManagerId : 'manager 1',
            },
            dateTime: {
              ...state.formDataValue.C.defaultSearch.dateTime,
              recorddatestart: json.StartDate ? moment(json.StartDate).format('MMM / DD / YYYY') : ' ',
              recorddateend: json.EndDate ? moment(json.EndDate).format('MMM / DD / YYYY') : ' ',
              dt1fr: json.ContractStartDate ? moment(json.ContractStartDate).format('MMM / DD / YYYY') : ' ',
              dt1to: json.ContractEndDate ? moment(json.ContractEndDate).format('MMM / DD / YYYY') : ' ',
              dt2fr: json.NextScheduledAction ? moment(json.NextScheduledAction).format('MMM / DD / YYYY') : ' ',
            },
          },
          annualValue: {
            textValues: {
              ti1r: json.AnnualContractValue ? json.AnnualContractValue : '',
            },
          },
          legisStates: {
            selected: json.ClientRegionsLegis,
          },
          regsStatesRegister: {
            selected: json.ClientRegionsRegsRegister,
          },
          regsStatesAgency: {
            selected: json.ClientRegionsRegsAgency,
          },
          locality: {
            selected: json.ClientLocalities,
          },
          viewingOptions: {
            selected: [],
            textValues: {
              archiveStartYear: json.ArchiveStartYear ? json.ArchiveStartYear : '',
            },
          },
        }
      },
      renderData: {
        ...state.renderData,
        C: {
          ...state.renderData.C,
          groupNotes: {
            ...state.renderData.C.groupNotes,
            currentClient: json,
          }
        }
      }
    }
  },
  [CLEAR_GROUP_NOTES] : (state) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
        C: {
          ...state.renderData.C,
          groupNotes: {
            ...state.renderData.C.groupNotes,
            groupNotes: {}
          }
        }
      }
    }
  }
}
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isFetchingData: false,
  errorCode: '',
  renderData: {
    C: {
      groupNotes: {},
    },
  },
  formDataValue: {
    C: {
      defaultSearch: {
        title: '',
        selected: [],
        textValues: {
          clientId: '',
          shortName: '',
          fullName: '',
          address0: '',
          address1: '',
          address2: '',
          address3: '',
          address4: '',
          address5: '',
          description: '',
          notes: '',
        },
        radio: {
          aType: 'type 1',
          aManager: 'manager 1',
        },
        dateTime: {
          recorddatestart: ' ',
          recorddateend: ' ',
          dt1fr: ' ',
          dt1to: ' ',
          dt2fr: ' ',
        },
      },
      viewingOptions: {
        selected: [],
        textValues: {
          archiveStartYear: '',
        },
      },
      clientOptions: {
        selected: [],
        radio: {
          trackingPerYear: '50',
        },
      },
      legisStates: {
        selected: [],
      },
      regsStatesRegister: {
        selected: [],
      },
      regsStatesAgency: {
        selected: [],
      },
      locality: {
        selected: [],
      },
      additionalFilters: {},
      clientContacts: {
        selected: [],
        textValues: {},
      },
      clientUsers: {
        selected: [],
        textValues: {},
      },
      findClient: {
        textValues: {
          search: '',
        }
      },
      groupNotes: {
        selected: [],
        dateTime: {},
        radio: {},
      },
      groupNotesTypes: {
        selected: [],
      },
      categories: {
        selected: []
      },
      annualValue: {
        textValues: {
          ti1r: '',
        },
      },
      pricingHistory: {
        textValues: {
          0: {
            pricingTerm: '',
            pricingAmount: '',
            pricingNotes: ''
          },
          pricingTerm: '2016-2018',
          pricingAmount: '$256.000',
          pricingNotes: '2-Year Agreement ($178.000/year)'
        },
        radio: {
          pricingType: 'Renewal'
        },
        selected: []
      },
      invoiceHistory: {
        textValues: {
          0: {
            invoice: '',
            amount: '',
            date: '',
            dateReceived: '',
            dateDeposited: '',
            dateDue: '',
            dateResent: ''
          },
          invoice: '102526',
          amount: '356,000.00',
          date: '4/18/18',
          dateReceived: '4/27/18',
          dateDeposited: '4/27/18',
          dateDue: '4/30/18',
          dateResent: ''
        }
      }
    }
  }
}
export default function clientsDataReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/clientManagementFormData.js